// @flow

import visa from '../../../assets/img/payment-methods/visa.png';
import discover from '../../../assets/img/payment-methods/discover.png';
import jcb from '../../../assets/img/payment-methods/jcb.png';
import mastercard from '../../../assets/img/payment-methods/mastercard.png';
import safetypay from '../../../assets/img/new-order/payment-method/safetypay.png';
import paypal from '../../../assets/img/new-order/payment-method/paypal.png';
import bitpay from '../../../assets/img/new-order/payment-method/bitcoin.png';
import kashio from '../../../assets/img/new-order/payment-method/kashio.png';

const payments = {
  visa,
  discover,
  jcb,
  mastercard,
  safetypay,
  paypal,
  bitpay,
  kashio,
};

import type { OrderInvoice } from '../../../entities';

/*
* description: 'getPaymentInfo' return a payment method image or a brand image from invoice response.
* return: string.
* observation: string in lowerCase.
*/
export function getPaymentInfo(invoice: OrderInvoice) {
  if (invoice.payment) {
    if ((invoice.payment.subtype === 'CARD' ||
      invoice.payment.subtype === 'DINERS' ||
      invoice.payment.subtype === 'CREDIT_CARD' ||
      invoice.payment.subtype === 'DEBIT' ||
      invoice.payment.subtype === 'DEBIT_CARD' ||
      invoice.payment.subtype === 'CRYPTO' ||
      invoice.payment.subtype === 'PAYPAL') &&
      (invoice.payment.paymentData && invoice.payment.paymentData.brand)) {
      return payments[invoice.payment.paymentData.brand.toLowerCase()];
    } else {
      return payments[invoice.payment.method.toLowerCase()];
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/new-order/CheckoutStep/utils.js